import * as Yup from "yup";

const Validation = Yup.object({
  name: Yup.string().trim().required("Required*"),
  email: Yup.string().email("Invalid email format").required("Required*"),
});

export default Validation;
